// Export the extractName function for testing
export function extractName(name: string) {
  if (!name) return name;

  // Handle combined case: "'Name' via Service" <email@domain.com>
  // or the format with quotes: "\"'Name' via Service\"" <email@domain.com>
  const combinedMatch = name.match(/^"?'?(.+?)'?"?\s+via\s+.+?"?\s*<.+>$/);
  if (combinedMatch) {
    return combinedMatch[1].trim();
  }

  // Handle "Name <email>" format
  const emailFormatMatch = name.match(/^(.+?)\s*<.+>$/);
  if (emailFormatMatch) {
    return emailFormatMatch[1].trim();
  }

  // Handle "'Name' via Service" format
  const viaFormatMatch = name.match(/^'?(.+?)'?\s+via\s+.+$/);
  if (viaFormatMatch) {
    return viaFormatMatch[1];
  }

  return name;
}

export function getInitials(name: string) {
  return name
    ? extractName(name)
        .split(" ")
        .map((n) => n[0])
        .filter((_, i, a) => {
          if (i === 0) return true;
          if (i === a.length - 1) return true;
          return false;
        })
        .join("")
        .toUpperCase()
    : "";
}
